export default "__VITE_ASSET__f409ab85__"